import { lazy } from 'react'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useRetrieveActiveContractIdAndType from './useRetrieveActiveContractIdAndType'
import useSaleFormObserver from '../Validations/useSaleFormObserver'
import PropTypes from 'prop-types'
import { SaleFormContainer } from './styled-components'
import { V2_COUNTRY_VERTICALS_AVAILABLE } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

// TAG: *AddNewBusinessVerticalOrCountry*
const salesFormAvailable = {
  'energy-be': lazy(() => import('./Energy/BELayout')),
  'energy-nl': lazy(() => import('./Energy/NLLayout')),
  'energy-fr': lazy(() => import('./Energy/FRLayout')),
  'energy-it': lazy(() => import('./Energy/ITLayout')),
  'energy-de': lazy(() => import('./Energy/DELayout')),
  'insurance-be': lazy(() => import('./Insurance/BELayout')),
  'insurance-fr': lazy(() => import('./Insurance/FRLayout')),
  'telecom-be': lazy(() => import('./Telecom/BELayout')),
  'telecom-fr': lazy(() => import('./Telecom/FRLayout')),
  'telecom-it': lazy(() => import('./Telecom/ITLayout')),
}

const SaleForm = ({ country, type }) => {
  const { zohoIsInValid, formIsLoaded } = useFormStatus()
  const { id } = useRetrieveActiveContractIdAndType()
  const formType = type + '-' + country
  const { validations } = useSaleFormObserver(type, country, id)
  const Element = id && salesFormAvailable[formType] ? salesFormAvailable[formType] : <div>Not implemented</div>
  if (zohoIsInValid) return <div>You need a valid Zoho id to continue</div>
  if (!formIsLoaded) return <div>Loading form data, please wait...</div>
  // TAG: *AddNewBusinessVerticalOrCountry V2_COUNTRY_VERTICALS_AVAILABLE constant*
  if (!validations && V2_COUNTRY_VERTICALS_AVAILABLE.includes(formType)) {
    return <div>Loading validation functions, please wait...</div>
  }

  return (
    <SaleFormContainer>
      <Element validations={validations} />
    </SaleFormContainer>
  )
}

SaleForm.propTypes = {
  country: PropTypes.string,
  type: PropTypes.string,
}

export default SaleForm
